import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';


import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material/material.module'
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { TranslationComponent } from './translation/translation.component';
import { WINDOW, WINDOW_PROVIDERS } from './window.provider';
import { AuthService } from './auth/auth.service';
import { TranslationService } from './translation/translation.service';
import { SignupComponent } from './auth/signup/signup.component';
import { LoginComponent } from './auth/login/login.component';
import { EditTranslationComponent } from './translation/edit-translation/edit-translation.component';
import { ListTranslationComponent } from './translation/list-translation/list-translation.component';
import { CreateTranslationComponent } from './translation/create-translation/create-translation.component';
import { HeaderComponent } from './navigation/header/header.component';
import { SidenavListComponent } from './navigation/sidenav-list/sidenav-list.component';
import { environment } from '../environments/environment';
import { UIService } from './shared/ui.service';
import { DealerComponent } from './dealer/dealer.component';
import { ListDealerComponent } from './dealer/list-dealer/list-dealer.component';
import { EditDealerComponent } from './dealer/edit-dealer/edit-dealer.component';
import { CreateDealerComponent } from './dealer/create-dealer/create-dealer.component';
import { DealerDetailsComponent } from './dealer/dealer-details/dealer-details.component';
import { AdmakerComponent } from './admaker/admaker.component';
import { AdmakerToolComponent } from './admaker/admaker-tool/admaker-tool.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProcessRunnerComponent } from './process-runner-select/process-runner.component';
import { ProcessRunComponent } from './process-runner-select/process-run/process-run.component';
import { AskerComponent } from './shared/asker/asker.component';
import { ResultComponent } from './process-runner-select/result/result.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ProcesslogComponent } from './processlog/processlog.component';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { ProcessLogsClientComponent } from './process-logs-client/process-logs-client.component';
import { MissingFieldsComponent } from './missing-fields/missing-fields.component';
import { MissingFieldsClientComponent } from './missing-fields/missing-fields-client/missing-fields-client.component';
import { InProgressProcessComponent } from './process-runner-select/process-run/in-progress-process/in-progress-process.component';
import { ProcessResultComponent } from './process-runner-select/process-run/process-result/process-result.component';
import { AncSettingsComponent } from './anc-settings/anc-settings.component';
import { ClientsTableComponent } from './anc-settings/clients-table/clients-table.component';
import { MatIconRegistry } from '@angular/material/icon';
import { SeedShowComponent } from './seed/seed-show/seed-show.component';
import { SeedTableComponent } from './seed/seed-table/seed-table.component';
import { SharedDialogComponent } from './shared/shared-dialog/shared-dialog.component';
import { SeedShowDealerComponent } from './seed/seed-show-dealer/seed-show-dealer.component';
@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    HomeComponent,
    ContactComponent,
    TranslationComponent,
    SignupComponent,
    LoginComponent,
    EditTranslationComponent,
    ListTranslationComponent,
    CreateTranslationComponent,
    HeaderComponent,
    SidenavListComponent,
    DealerComponent,
    ListDealerComponent,
    EditDealerComponent,
    CreateDealerComponent,
    DealerDetailsComponent,
    AdmakerComponent,
    AdmakerToolComponent,
    ProcessRunnerComponent,
    ProcessRunComponent,
    AskerComponent,
    ResultComponent,
    ProcesslogComponent,
    ProcessLogsClientComponent,
    MissingFieldsComponent,
    MissingFieldsClientComponent,
    InProgressProcessComponent,
    ProcessResultComponent,
    AncSettingsComponent,
    ClientsTableComponent,
    SeedShowComponent,
    SeedTableComponent,
    SharedDialogComponent,
    SeedShowDealerComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    DragDropModule,
    MatNativeDateModule
  ],
  providers: [
    WINDOW_PROVIDERS,
    AuthService,
    TranslationService,
    UIService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },

  ],
  bootstrap: [AppComponent],
  entryComponents: [CreateTranslationComponent]
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    let ex = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="800.000000pt" height="880.000000pt" viewBox="0 0 800.000000 880.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,880.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M926 6365 c-21 -7 -52 -26 -68 -42 -59 -56 -58 -44 -58 -658 l0 -563
23 -42 c12 -24 37 -54 56 -69 l34 -26 1296 -5 1295 -5 114 -155 c62 -85 121
-165 129 -177 17 -26 56 28 -326 -453 -129 -162 -276 -347 -326 -410 -207
-262 -373 -471 -445 -560 -42 -52 -79 -101 -83 -107 -7 -10 91 -13 473 -13
l480 0 162 217 c89 120 213 288 276 373 215 289 254 340 263 340 5 0 32 -34
61 -77 29 -42 69 -98 88 -124 19 -27 143 -202 275 -389 l240 -340 351 0 c312
0 353 -2 358 -16 12 -31 7 -762 -5 -770 -7 -4 -71 -7 -143 -8 -131 -1 -155 -6
-198 -44 -26 -22 -24 -98 3 -142 23 -37 211 -252 251 -285 12 -11 46 -45 73
-75 85 -94 267 -291 341 -370 66 -70 108 -116 201 -216 85 -93 121 -86 240 44
49 52 243 262 432 466 189 204 356 388 372 409 29 40 46 110 35 145 -15 46
-51 57 -211 62 l-150 5 -5 535 c-5 504 -6 537 -24 563 -39 57 -42 58 -600 57
-557 0 -531 2 -583 -59 -13 -15 -20 -19 -17 -9 5 16 -49 89 -611 823 -237 310
-305 401 -305 407 0 4 227 302 505 663 278 361 505 658 505 660 0 3 -222 5
-493 5 l-493 0 -239 -355 c-131 -195 -244 -355 -251 -355 -6 0 -45 53 -85 118
-41 64 -93 146 -116 182 l-43 65 0 291 c0 160 -5 315 -10 344 -12 66 -50 116
-104 141 -39 18 -95 19 -1471 18 -1189 0 -1437 -2 -1469 -14z m1661 -365 c42
-24 57 -40 82 -91 17 -34 31 -68 31 -74 0 -7 -20 -18 -44 -24 -24 -6 -50 -13
-58 -16 -10 -4 -19 6 -30 34 -32 80 -122 101 -183 41 -44 -43 -59 -108 -53
-226 7 -138 46 -199 129 -199 49 0 96 43 110 102 l11 41 59 -21 c58 -21 59
-22 53 -52 -30 -141 -149 -223 -282 -194 -71 15 -122 55 -159 125 -54 102 -67
228 -38 352 37 155 121 231 255 232 54 0 74 -5 117 -30z m-1067 -40 l0 -60
-150 0 -150 0 0 -75 0 -75 140 0 140 0 0 -60 0 -60 -140 0 -140 0 0 -90 0 -90
155 0 155 0 0 -60 0 -60 -220 0 -220 0 0 345 0 345 215 0 215 0 0 -60z m292
-38 c28 -50 54 -90 58 -87 5 3 30 46 57 95 l48 90 68 0 c82 0 85 18 -24 -183
l-79 -148 95 -175 c52 -96 95 -177 95 -179 0 -3 -33 -5 -72 -5 l-73 0 -59 111
-58 111 -24 -42 c-13 -23 -40 -73 -60 -111 l-36 -69 -75 0 c-41 0 -72 3 -70 8
52 90 187 343 187 350 0 5 -38 80 -85 167 -47 88 -85 161 -85 163 0 1 32 2 72
0 l71 -3 49 -93z m1448 38 l0 -60 -155 0 -155 0 0 -75 0 -75 140 0 140 0 0
-60 0 -60 -140 0 -140 0 0 -90 0 -90 160 0 160 0 0 -60 0 -60 -220 0 -220 0 0
345 0 345 215 0 215 0 0 -60z m258 -227 l2 -283 140 0 140 0 0 -60 0 -60 -205
0 -205 0 0 338 c0 186 3 342 7 346 4 4 32 6 63 4 l55 -3 3 -282z"/>
</g>
</svg>
`;

    iconRegistry.addSvgIconLiteral(
      'exceldload', sanitizer.bypassSecurityTrustHtml(ex));
  }
}
